export const utf8ToBase64 = (string: string): string => window.btoa(encodeURIComponent(string));

export const base64ToUtf8 = (string: string): string => {
  return decodeURIComponent(window.atob(string));
};

export const getInitials = (value: string): string => {
  if (!value.trim()) return '';

  const words = value.trim().split(/\s+/);

  const initials = words
    .map((word): string => {
      const firstLetter = word.match(/[A-Za-z]/);
      return firstLetter ? firstLetter[0].toUpperCase() : '';
    })
    .join('');

  return initials;
};

/**
 * Generates initials from a full name following the standardized pattern.
 * Prioritizes first name + last name format (first and last word).
 * Falls back to first 2 words if name has less than 2 words.
 * Maximum of 2 initials will be returned.
 * Example: "John Doe" -> "JD", "Mary Jane Smith" -> "MS", "John" -> "J"
 */
export const getInitialsStandardized = (name: string): string => {
  const words = name.split(' ').filter(Boolean);

  if (words.length === 0) return '';
  if (words.length === 1) return words[0][0].toUpperCase();

  // Use first character of first word and first character of last word
  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};
